import { observer } from 'mobx-react-lite';

import { DetailsList, IDetailsListProps } from 'office-ui-fabric-react/lib/DetailsList';
import * as React from 'react';
import LoadMoreDataZone, {
    LoadMoreDataComponentProps,
} from 'owa-loadmore-listview/lib/components/LoadMoreDataZone';

export interface LoadMoreDetailsListProps extends LoadMoreDataComponentProps {
    detailsListProps: IDetailsListProps;

    // Draws the loading component at the bottom while fetching more data
    loadingComponent?: JSX.Element;
}

export default observer(function LoadMoreDetailsList(props: LoadMoreDetailsListProps) {
    const renderRows = (rowsToRender: number): JSX.Element => {
        const detailsListProps = {
            ...props.detailsListProps,
            items: props.detailsListProps.items.slice(0, rowsToRender),
        };
        const isLoadInProgress = props.isLoadRowsInProgress;
        return (
            <div>
                <DetailsList {...detailsListProps} />
                {isLoadInProgress && props.loadingComponent}
            </div>
        );
    };
    return (
        <LoadMoreDataZone
            className={props.className}
            dataSourceId={props.dataSourceId}
            totalRows={props.detailsListProps.items.length}
            onRenderRows={renderRows}
            onLoadMoreRows={props.onLoadMoreRows}
            isLoadRowsInProgress={props.isLoadRowsInProgress}
            getCanLoadMore={props.getCanLoadMore}
            onWillUpdate={props.onWillUpdate}
            onDidUpdate={props.onDidUpdate}
            currentLoadedIndex={props.currentLoadedIndex}
            guardPageCount={props.guardPageCount}
        />
    );
});
